import cx from "classnames";
import React from "react";

import { Icon } from "@/components/elements/Icon";

import styles from "./styles.module.css";

export type LoadingSpinnerProps = {
  size?: "small" | "regular" | "medium" | "large";
  theme?: "dark" | "light";
  isAnimated?: boolean;
  centreOnPage?: boolean;
  className?: string;
  iconClassName?: string;
};

export const LoadingSpinner = ({
  size = "regular",
  theme = "light",
  isAnimated = true,
  centreOnPage,
  className,
  iconClassName,
}: LoadingSpinnerProps) => {
  return (
    <div
      className={cx(
        styles.container,
        { [styles._centred]: centreOnPage },
        styles[theme],
        className
      )}
    >
      <Icon
        type="spinner"
        label="Loading"
        className={cx(
          styles.icon,
          styles[size],
          { [styles._isAnimated]: isAnimated },
          iconClassName
        )}
      />
    </div>
  );
};
